import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import PartnersGridUI from 'hb-builder/components/UIComponents/page/block/Partners/PartnersGrid/PartnersGridUI';
import type { RenderComponent } from 'hb-builder/types';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

const PartnersGrid: RenderComponent = () => <div />; // never used

const Render = ({
  children,
  item,
}: RenderProps<DocumentItem<PartnersItemAttributes>>) => (
  <PartnersGridUI attributes={item?.attributes}>{children}</PartnersGridUI>
);

PartnersGrid.componentName = 'PartnersGrid';
PartnersGrid.Render = Render;

PartnersGrid.item = ({ attributes, children }) => ({
  attributes,
  children,
  type: PartnersGrid.componentName,
});

export default PartnersGrid;
